var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("div", { staticClass: "details" }, [
      _c("h3", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.manager.name) +
            " – " +
            _vm._s(_vm.manager.company) +
            "\n      "
        ),
        _vm.$vlastMode && _vm.manager.activation_notified_at
          ? _c("span", { staticClass: "small" }, [
              _vm._v(
                "(Activation Email Sent: " +
                  _vm._s(
                    _vm._f("dateTimezone")(
                      _vm.manager.activation_notified_at,
                      _vm.$user.timezone,
                      _vm.$user.date_format_preference,
                      true,
                      true
                    )
                  ) +
                  ")"
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-6 col-lg-3" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm btn-block btn-default",
                attrs: {
                  tag: "a",
                  to: {
                    name: "managers.profile.show",
                    params: { id: _vm.manager.id },
                  },
                  exact: "",
                },
              },
              [_vm._v("\n          Profile\n        ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-6 col-lg-3" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm btn-block btn-default",
                attrs: {
                  tag: "a",
                  to: {
                    name: "managers.talent.index",
                    params: { managerId: _vm.manager.id },
                  },
                  exact: "",
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural)) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-6 col-lg-3" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm btn-block btn-default",
                attrs: {
                  tag: "a",
                  to: {
                    name: "managers.requests.index",
                    params: { managerId: _vm.manager.id },
                  },
                  exact: "",
                },
              },
              [_vm._v("\n          Requests\n        ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-6 col-lg-3" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm btn-block btn-default",
                attrs: {
                  tag: "a",
                  to: {
                    name: "managers.bookings.index",
                    params: { managerId: _vm.manager.id },
                  },
                  exact: "",
                },
              },
              [_vm._v("\n          Bookings\n        ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }